:host {
  display: block;
  width: 100%;
}
